export enum AnalyticsEvents {
  BUTTON_CLICK = 'BUTTON_CLICK',
  PAGE_VIEW = 'PAGE_VIEW',
}

export enum KeyboardEvents {
  TYPE = 'keydown',
  ENTER = 'Enter',
  FORWARD_SLASH = '/',
}

export enum EnableOrDisable {
  ENABLE = 'ENABLE',
  DISABLE = 'DISABLE',
}
